<script setup lang="ts">

import { useUserFetch } from '~/composables/useUserApi';
import type { Link } from '~/models/links';
import { linkIcons } from '~/models/links';
import type { News } from '~/models/news';
const { data: links, refresh, pending } = await useUserFetch<Link[]>('/api/links');
const { data: nyheter, refresh: refreshNyheter, pending: pendingNyheter } = await useUserFetch<News[]>('/api/news');

</script>
<template>
  <div class="p-4 mainColor container mx-auto max-w-screen-lg">
    <SectionHeader header="Øyeblikkelig hjelp"  >
      Legekontor, legevakt eller medisinsk nødtelefon? Hva skal du velge når du
      trenger øyeblikkelig hjelp? Her får du oversikt over nødnummer.
    </SectionHeader>
    <div v-if="!pending" class="grid md:grid-cols-2  gap-6">
      <a target="_blank" v-for="link in links" :key="link.id" :href="link.url" class="bg-white rounded-lg shadow-md">
        <div class="grid grid-cols-4 h-full">

          <div class="col-span-1 mainColorBackground flex justify-center items-center w-full">
            <Icon :name="linkIcons.find(i => i.value === link.icon)?.iconname || 'undefined'" size="7em" />
          </div>
          <div class="col-span-3 px-6 py-8 justify-center items-center flex flex-col mainColor">
            <h2 class="text-2xl font-bold mb-2">{{ link.title }}</h2>
            <p class="text-gray-600 mb-2">{{ link.description }}</p>
          </div>

        </div>
      </a>
    </div>
    <!-- <iframe class="w-full h-96 mt-4"  style="border:0" loading="lazy" allowfullscreen
      referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed/v1/view?key=AIzaSyDQ3aQR0JGgK8judDokbbAf95JhRzM6mNQ
    &center=59.3517,10.8757
  &zoom=18
  &maptype=roadmap">  
    </iframe> -->
    <!-- <iframe class="w-full h-96 mt-4" style="border:0" loading="lazy" allowfullscreen
      referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDQ3aQR0JGgK8judDokbbAf95JhRzM6mNQ
    &q=Sarpsborgveien%207E%2C%201640%20R%C3%A5de">
    </iframe> -->
  </div>
</template>
